
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Aix-en-Provence dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Aix-en-Provence certifiée Google Partner, accompagne les entreprises aixoises pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Aix-en-Provence dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Aix-en-Provence certifiée Google Partner, accompagne les entreprises aixoises pour augmenter leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
